/**
 * Singapore PSI tiers. Kept free of browser and Vite-only APIs so the same data
 * can drive both designs and the share-image generator.
 */

export type TierId = 'clean' | 'moderate' | 'unhealthy' | 'very_unhealthy' | 'hazardous';

export interface AirTier {
  id: TierId;
  name: string;
  range: readonly [number, number];
  advisory: string;
}

export const TIERS: Record<TierId, AirTier> = {
  clean: {
    id: 'clean',
    name: 'Clean',
    range: [0, 50],
    advisory: 'Normal outdoor activities for everyone.',
  },
  moderate: {
    id: 'moderate',
    name: 'Moderate',
    range: [51, 100],
    advisory: 'Normal activities.',
  },
  unhealthy: {
    id: 'unhealthy',
    name: 'Unhealthy',
    range: [101, 200],
    advisory: 'Reduce prolonged or strenuous outdoor physical exertion.',
  },
  very_unhealthy: {
    id: 'very_unhealthy',
    name: 'Very Unhealthy',
    range: [201, 300],
    advisory: 'Avoid prolonged or strenuous outdoor exertion.',
  },
  hazardous: {
    id: 'hazardous',
    name: 'Hazardous',
    range: [301, Number.MAX_SAFE_INTEGER],
    advisory: 'Minimize outdoor activity.',
  },
};

export function getTierForPsi(psi: number): AirTier {
  const value = Number.isFinite(psi) ? Math.max(0, Math.round(psi)) : 0;
  if (value <= 50) return TIERS.clean;
  if (value <= 100) return TIERS.moderate;
  if (value <= 200) return TIERS.unhealthy;
  if (value <= 300) return TIERS.very_unhealthy;
  return TIERS.hazardous;
}
